import { Box, NativeSelect } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { useTranslation } from "react-i18next";

export default function Pagination(props) {
  const { t } = useTranslation();

  const handleNext = () => {
    if (props.page < props.totalPages) props.setPage(props.page + 1);
  };

  const handlePrev = () => {
    if (props.page > 1) props.setPage(props.page - 1);
  };

  const handlePage = (page) => {
    props.setPage(page);
  };

  const handleLimit = (event) => {
    props.setPage(1);
    props.setLimit(event.target.value);
  };

  const paginationUnselected =
    "w-8 h-8 inline-flex text-sm justify-center items-center text-slate-400 hover:text-white bg-white dark:bg-slate-900 border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500";
  const paginationSelected =
    "z-10 w-8 h-8 inline-flex text-sm justify-center items-center text-white bg-orange-500 border border-orange-500";
  const paginationDisabled =
    "z-10 w-8 h-8 inline-flex text-sm justify-center items-center text-gray bg-white-500 border border-white-500";

  return (
    <>
      {/* pagination start */}
      <div
        class="grid md:grid-cols-12 grid-cols-1 mt-10 p-4 rounded-lg"
        style={{ backgroundColor: "#eeededff" }}
      >
        <div class="md:col-span-12 text-center">
          <nav aria-label="Page navigation example">
            <ul class="inline-flex items-center -space-x-px">
              <li>
                <buton
                  class="w-8 h-8 inline-flex text-sm justify-center items-center text-slate-400 bg-white dark:bg-slate-900 rounded-s-xl hover:text-white border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500"
                  onClick={handlePrev}
                  disabled={props.page === 1}
                >
                  <i class="mdi mdi-chevron-left text-[20px] rtl:rotate-180"></i>
                </buton>
              </li>
              <li>
                <button
                  class={
                    1 > props.totalPages
                      ? paginationDisabled
                      : props.page === 2
                      ? paginationSelected
                      : paginationUnselected
                  }
                  onClick={() => handlePage(1)}
                  disabled={1 > props.totalPages}
                >
                  1
                </button>
              </li>
              <li>
                <button
                  class={
                    2 > props.totalPages
                      ? paginationDisabled
                      : props.page === 2
                      ? paginationSelected
                      : paginationUnselected
                  }
                  onClick={() => handlePage(2)}
                  disabled={2 > props.totalPages}
                >
                  2
                </button>
              </li>
              <li>
                <button
                  class={
                    3 > props.totalPages
                      ? paginationDisabled
                      : props.page === 2
                      ? paginationSelected
                      : paginationUnselected
                  }
                  onClick={() => handlePage(3)}
                  disabled={3 > props.totalPages}
                >
                  3
                </button>
              </li>
              <li>
                <button
                  class={
                    4 > props.totalPages
                      ? paginationDisabled
                      : props.page === 2
                      ? paginationSelected
                      : paginationUnselected
                  }
                  onClick={() => handlePage(4)}
                  disabled={4 > props.totalPages}
                >
                  4
                </button>
              </li>
              <li>
                <button
                  class={
                    5 > props.totalPages
                      ? paginationDisabled
                      : props.page === 2
                      ? paginationSelected
                      : paginationUnselected
                  }
                  onClick={() => handlePage(5)}
                  disabled={5 > props.totalPages}
                >
                  5
                </button>
              </li>
              <li>
                <button
                  class="w-8 h-8 inline-flex text-sm justify-center items-center text-slate-400 bg-white dark:bg-slate-900 rounded-e-xl hover:text-white border border-gray-100 dark:border-gray-800 hover:border-orange-500 dark:hover:border-orange-500 hover:bg-orange-500 dark:hover:bg-orange-500"
                  onClick={handleNext}
                  disabled={props.page === props.totalPages}
                >
                  <i class="mdi mdi-chevron-right text-[20px] rtl:rotate-180"></i>
                </button>
              </li>
            </ul>
          </nav>
          <div
            style={{
              marginTop: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span>
              {t("common.page")} {props.page} {t("common.of")}{" "}
              {props.totalPages} {t("common.by")} {props.total}{" "}
              {t("common.registers")}
            </span>
            <Box sx={{ marginLeft: 5 }}>
              <span>{t("common.items_per_page")}:&nbsp;&nbsp;</span>
              <FormControl>
                <NativeSelect
                  id="demo-simple-select"
                  defaultValue={props.limit}
                  label="Items Per Page"
                  onChange={handleLimit}
                  sx={{ width: 60, marginTop: -1 }}
                >
                  <option value={props.firstOption ? props.firstOption : 3}>
                    {props.firstOption ? props.firstOption : 3}
                  </option>
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                </NativeSelect>
              </FormControl>
            </Box>
          </div>
        </div>
      </div>
      {/* pagination end */}
    </>
  );
}
